import { PanoramaVariantOutlineIcon } from './PanoramaVariantOutlineIcon';

/**
 * author: Google
 * id BE67BFD1-97AD-4EC3-B3E7-19BA48708172
 * name panorama-variant-outline
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/panorama-variant-outline.svg
 * tags
 * - Photography 
 */
export const ImageVrOutlineIcon = PanoramaVariantOutlineIcon;
export default ImageVrOutlineIcon